/* eslint-disable no-loop-func */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from 'react'
import _, { indexOf } from 'lodash';
import { message } from '../components/SocketIO'
import RotaDriverRow from './RotaDriverRow';
import { useSelector, useDispatch } from 'react-redux';
import {
    addRota,
    selectRotaData
} from '../features/rota/rotaSlice'
import GetSchedule from '../backendHandler/schedulingRoute'

let latestClick = null

// eslint-disable-next-line no-extend-native
Date.prototype.getWeek = function () {
    var firstDate = new Date(this.getFullYear(), 0, 1)
    if (this.getFullYear() === 2021) {
        return Math.ceil((((new Date(this.getFullYear(), this.getMonth(), this.getDate()) - firstDate) / 86400000) + firstDate.getDay() + 1) / 7) - 1
    } else {
        return Math.ceil((((new Date(this.getFullYear(), this.getMonth(), this.getDate()) - firstDate) / 86400000) + firstDate.getDay() + 1) / 7)
    }
}


const determineOffboarded = (offboradedContent, selectedFunctionDate) => {
    switch (offboradedContent) {
        case 'OffboardedForever':
            return false
        case 'Active':
            return true
        case 'verified':
            return true
        case null:
            return true        
        default:
            if (new Date(offboradedContent).getWeek() < new Date(selectedFunctionDate).getWeek()) {
                return false
            } else {
                return true
            }
    }
}

const DivSingleWeek = (props) => {
    // redux
    const rotaData = useSelector(selectRotaData)
    const dispatch = useDispatch()

    // using the new backend route
    const [ requestGate, setRequestGate ] = useState(false)
    const [ handleSchedule, setHandleSchedule ] = useState(null)
    const [ dateSelection, setDateSelection ] = useState(new Date())

    useEffect( () => {
        setHandleSchedule(
            <>
                <GetSchedule 
                    allGate={false}
                    dateSelection={dateSelection}
                />
            </>
        )
    }, [requestGate, dateSelection])
    
    var CryptoJS = require("crypto-js");
    const [ topRow, setTopRow ] = useState([])
    const [ middleRow, setMiddleRow ] = useState([])
    const [ totalRoutesGiven, setTotalRoutesGiven ] = useState([])
    const [ totalDaAvailable, setTotalDaAvailable ] = useState([])
    const [ totalSpareDa, setTotalSpareDa ] = useState([])
    const [ getData, setGetData ] = useState(false)
    const [ data, setData ] = useState([])
    const [ driverData, setDriverData ] = useState(null)
    const [ calenderDivs, setCalendarDivs ] = useState('cal_divs_single')
    const [ calenderDivsInner, setCalendarDivsInner ] = useState('cal_divs_single_table')
    const [ calenderDivsInnerBooked, setCalendarDivsInnerBooked ] = useState('cal_divs_single_booked')
    const [ middleRowClass, setMiddleRowClass] = useState('middle_row')
    const [ selectedResponse, setSelectedResponse ] = useState('')
    const [ menuVisibility, setMenuVisibility ] = useState(null)
    const [ errorMessage, setErrorMessage ] = useState(null)
    const [ inputRouteAmount, setInputeRouteAmount ] = useState(0)
    const [ dateForEntry, setDateForEntry ] = useState('')
    const [ entryGate, setEntryGate ] = useState(false)
    const [ putGate, setPutGate ] = useState(false)
    const [ selectedRoute, setSelectedRoute ] = useState(null)
    const [ daAvailableArray, setDaAvailableArray ] = useState([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])
    const [ routesGivenArray, setRoutesGivenArray ] = useState([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])
    const [ stateMenu, setStateMenu ] = useState(0)
    const [ socketGate, setSocketGate ] = useState(false)
    const [topClassName, setTopClassName] = useState("top_row")
    const [bottomRows, setBottomRows] = useState('bottom_row')
    const [bottomRowContainers, setBottomRowContainers] = useState('bottom_rows_conatiners')

    // add the 21 version
    const [ weekGrid, setWeekGrid ] = useState('single_week_grid')

    useEffect( () => {
        if (props.selectedDate) {
            if (rotaData[`${props.selectedDate}`] !== undefined) {
                setDriverData(rotaData[`${props.selectedDate}`].drivers) 
                setData(rotaData[`${props.selectedDate}`])
            }
        }
    }, [props.selectedDate, rotaData])

    // the socket
    // useEffect( () => {
    //     // connec to the socket
    //     message((err, message) => {
    //         if (props.selectedDate) {
    //             setSelectedResponse(props.selectedCity)
    //         }
    //     }, 'I have joined the chat', props.user_name)
    // }, [socketGate, props.autoToggle])

    // handle grabbing the data
    useEffect( () => {
        if (props.selectedDate !== '') {
            let theDateWeek = new Date(props.selectedDate)
            setDateSelection(theDateWeek)
        }
    }, [props.selectedDate, getData, props.autoToggle])

    const handleDeleteError = () => {
        setErrorMessage(null)
        setEntryGate(false)
        setPutGate(false)
        setInputeRouteAmount(0)
    }

    const handleDeleteToggle = (e, driver) => {
        props.deletionDriver(e, driver)
    }

    const handleUnDeleteToggle = (e, driver) => {
        props.unDeletionDriver(e, driver)
    }

    // change the amount wanting to submit
    const handleChangeRouteAmount = (e) => {
        setInputeRouteAmount(e.target.value)
    }

    // handle submitting number of routes for day
    const handleSubmitRoutesGivenPost = (e) => {
        e.preventDefault()
        let myDateTime = new Date()
        let hours = myDateTime.getHours()
        let minutes = myDateTime.getMinutes()

        let timeEntry = `00:00`
        async function postData(url = '', data = {}) {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'POST', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                },
                body: JSON.stringify(data)
                });

            return response ? response.json() : console.log('no reponse')
        };

        postData(`https://backendpajamas.herokuapp.com/schedule/`, {
            date: dateForEntry,
            logIn_time: timeEntry,
            logOut_time: timeEntry,
            name: 'bottomRoutes',
            location: props.selectedCity,
            routeNumber: inputRouteAmount,
            week_number: new Date(dateForEntry).getWeek()
        }).then( response => {
            handleDeleteError()
            getData ? setGetData(false) : setGetData(true)
        })
    }

    // handle the put version of submitting daily route amount
    const handleSubmitRoutesGivenPut = (e) => {
        // eslint-disable-next-line no-extend-native
        Date.prototype.getWeek = function () {
            var firstDate = new Date(this.getFullYear(), 0, 1)
            if (this.getFullYear() === 2021) {
                return Math.ceil((((new Date(this.getFullYear(), this.getMonth(), this.getDate()) - firstDate) / 86400000) + firstDate.getDay() + 1) / 7) - 1
            } else {
                return Math.ceil((((new Date(this.getFullYear(), this.getMonth(), this.getDate()) - firstDate) / 86400000) + firstDate.getDay() + 1) / 7)
            }
        }
        e.preventDefault()
        let myDateTime = new Date()
        let hours = myDateTime.getHours()
        let minutes = myDateTime.getMinutes()

        let timeEntry = `00:00`
        async function postData(url = '', data = {}) {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'PUT', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                },
                body: JSON.stringify(data)
                });

            return response ? response.json() : console.log('no reponse')
        };

        postData(`https://backendpajamas.herokuapp.com/schedule/${selectedRoute.date_id}/`, {
            routeNumber: inputRouteAmount,
            logIn_time: timeEntry,
            logOut_time: timeEntry,
        }).then( response => {
            handleDeleteError()
            getData ? setGetData(false) : setGetData(true)
        })
    }

    // use effect to handle data entry on bottom portions
    useEffect( () => {
        if (entryGate) {
            setErrorMessage(
                <div className='errorMessageAllPages'>
                    <h2 id='errorMessage'>Set routes given for: {dateForEntry}</h2>
                    <input type="text" value={inputRouteAmount} onChange={handleChangeRouteAmount}/>
                    <div className='docsButtonsContainers'>
                        <button className='errorButtonReturn' onClick={handleDeleteError}>Return</button>
                        <button className='errorButtonSubmit' onClick={handleSubmitRoutesGivenPost}>Submit</button>
                    </div>
                </div>
            )
        }
    }, [dateForEntry, entryGate, inputRouteAmount])

    // use effect to handle data entry on bottom portions
    useEffect( () => {
        if (putGate && selectedRoute) {
            setErrorMessage(
                <div className='errorMessageAllPages'>
                    <h2 id='errorMessage'>Set routes given for: {selectedRoute.date}</h2>
                    <input type="text" value={inputRouteAmount} onChange={handleChangeRouteAmount}/>
                    <div className='docsButtonsContainers'>
                        <button className='errorButtonReturn' onClick={handleDeleteError}>Return</button>
                        <button className='errorButtonSubmit' onClick={handleSubmitRoutesGivenPut}>Submit</button>
                    </div>
                </div>
            )
        }
    }, [dateForEntry, putGate, inputRouteAmount, selectedRoute])

    // function for setting the amount of routes given on teh bottom
    const handleSetRoutesGiven = (e, item) => {
        let localDate
        let dateVar
        if (item < 7) {
            localDate = new Date(props.selectedDate)
            dateVar = new Date(localDate.setDate(localDate.getDate() + item)).toDateString()
            setDateForEntry(dateVar)
            setEntryGate(true)
        } else if (item === 7) {
            console.log(' Why you clicking there?')
        } else {
            let newItem = item - 1
            localDate = new Date(props.selectedDate)
            dateVar = new Date(localDate.setDate(localDate.getDate() + (newItem))).toDateString()
            setDateForEntry(dateVar)
            setEntryGate(true)
        }
    }

    // function for handling the put route
    const handleSetRoutesGivenPut = (e, item) => {
        e.preventDefault()
        setSelectedRoute(item)
        setInputeRouteAmount(parseInt(item.routeNumber))
        setPutGate(true)
    }

    // calculate the amount of routes
    useEffect( () => {
        let amount = parseInt(props.divAmount)
        let localDate = new Date(props.selectedDate)
        let localDateArray = []
        let arrayToPushForComparison = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        
        function totalRoutesGiven () {
            let routeSumMiddle = 0
            let routeSumEnd = 0
            let veryEndSum = 0
            let localDate = new Date(props.selectedDate)
            // make array for display and push forst column
                var lastWeekDivsArray = []
                lastWeekDivsArray.push(<div className='cal_divs_single_first_top_bottom'><h4 className='inner_calander_text'>Total Routes Given:</h4></div>)
                if (amount === 14) {
                    for (let i = 0; i < 16; i++) {
                        lastWeekDivsArray.push(
                            <div className={`cal_divs_single_bottom`} onClick={(e, item) => handleSetRoutesGiven(e, i)}>
                                <h4 className='inner_calander_text'>
                                    0
                                </h4>
                            </div>
                        )
                    }
                    for (let i = 0; i < 14; i++) {
                        let dateVar = new Date(localDate.setDate(localDate.getDate() + i)).toDateString()
                        localDate = new Date(props.selectedDate)
                        localDateArray.push(
                            dateVar
                        )
                    }
                    if (data.bottomArray) {
                        data.bottomArray.forEach( date => {
                            if (localDateArray.includes(date.date) && date.location === props.selectedCity) {
                                if (localDateArray.indexOf(date.date) >= 7) {
                                    lastWeekDivsArray[localDateArray.indexOf(date.date) + 2] = (
                                        <div 
                                            className={`cal_divs_single_bottom`} 
                                            onClick={(e, item) => handleSetRoutesGivenPut(e, date)}
                                        >
                                            <h4 className='inner_calander_text'>
                                                {parseInt(date.routeNumber)}
                                            </h4>
                                        </div>
                                    )
                                    routeSumEnd += parseInt(date.routeNumber)
                                    arrayToPushForComparison[localDateArray.indexOf(date.date) + 1] = parseInt(date.routeNumber)
                                } else if (localDateArray.indexOf(date.date) < 7) {
                                    lastWeekDivsArray[localDateArray.indexOf(date.date) + 1] = (
                                        <div 
                                            className={`cal_divs_single_bottom`} 
                                            onClick={(e, item) => handleSetRoutesGivenPut(e, date)}
                                        >
                                            <h4 className='inner_calander_text'>
                                                {parseInt(date.routeNumber)}
                                            </h4>
                                        </div>
                                    )
                                    routeSumMiddle += parseInt(date.routeNumber)
                                    arrayToPushForComparison[localDateArray.indexOf(date.date)] = parseInt(date.routeNumber)
                                }
                            }
                        })
                        lastWeekDivsArray[8] = (
                            <div 
                                className={`cal_divs_single_bottom`} 
                            >
                                <h4 className='inner_calander_text'>
                                    {routeSumMiddle}
                                </h4>
                            </div>
                        )
                        lastWeekDivsArray[16] = (
                            <div 
                                className={`cal_divs_single_bottom`} 
                            >
                                <h4 className='inner_calander_text'>
                                    {routeSumEnd}
                                </h4>
                            </div>
                        )
                        arrayToPushForComparison[7] = routeSumMiddle
                        arrayToPushForComparison[15] = routeSumEnd
                    }
                } else if (amount === 21) {
                    for (let i = 0; i < 23; i++) {
                        lastWeekDivsArray.push(
                            <div className={`cal_divs_single_bottom`} onClick={(e, item) => handleSetRoutesGiven(e, i)}>
                                <h4 className='inner_calander_text'>
                                    0
                                </h4>
                            </div>
                        )
                    }
                    for (let i = 0; i < 21; i++) {
                        let dateVar = new Date(localDate.setDate(localDate.getDate() + i)).toDateString()
                        localDate = new Date(props.selectedDate)
                        localDateArray.push(
                            dateVar
                        )
                    }
                    if (data.bottomArray) {
                        data.bottomArray.forEach( date => {
                            if (localDateArray.includes(date.date) && date.location === props.selectedCity) {
                                if (localDateArray.indexOf(date.date) >= 7 && localDateArray.indexOf(date.date) < 14) {
                                    lastWeekDivsArray[localDateArray.indexOf(date.date) + 2] = (
                                        <div 
                                            className={`cal_divs_single_bottom`} 
                                            onClick={(e, item) => handleSetRoutesGivenPut(e, date)}
                                        >
                                            <h4 className='inner_calander_text'>
                                                {parseInt(date.routeNumber)}
                                            </h4>
                                        </div>
                                    )
                                    routeSumEnd += parseInt(date.routeNumber)
                                    arrayToPushForComparison[localDateArray.indexOf(date.date) + 1] = parseInt(date.routeNumber)
                                } else if (localDateArray.indexOf(date.date) < 7) {
                                    lastWeekDivsArray[localDateArray.indexOf(date.date) + 1] = (
                                        <div 
                                            className={`cal_divs_single_bottom`} 
                                            onClick={(e, item) => handleSetRoutesGivenPut(e, date)}
                                        >
                                            <h4 className='inner_calander_text'>
                                                {parseInt(date.routeNumber)}
                                            </h4>
                                        </div>
                                    )
                                    routeSumMiddle += parseInt(date.routeNumber)
                                    arrayToPushForComparison[localDateArray.indexOf(date.date)] = parseInt(date.routeNumber)
                                } else {
                                    lastWeekDivsArray[localDateArray.indexOf(date.date) + 3] = (
                                        <div 
                                            className={`cal_divs_single_bottom`} 
                                            onClick={(e, item) => handleSetRoutesGivenPut(e, date)}
                                        >
                                            <h4 className='inner_calander_text'>
                                                {parseInt(date.routeNumber)}
                                            </h4>
                                        </div>
                                    )
                                    veryEndSum += parseInt(date.routeNumber)
                                    arrayToPushForComparison[localDateArray.indexOf(date.date)] = parseInt(date.routeNumber)
                                }
                            }
                        })
                        lastWeekDivsArray[8] = (
                            <div 
                                className={`cal_divs_single_bottom`} 
                            >
                                <h4 className='inner_calander_text'>
                                    {routeSumMiddle}
                                </h4>
                            </div>
                        )
                        lastWeekDivsArray[16] = (
                            <div 
                                className={`cal_divs_single_bottom`} 
                            >
                                <h4 className='inner_calander_text'>
                                    {routeSumEnd}
                                </h4>
                            </div>
                        )
                        lastWeekDivsArray[24] = (
                            <div 
                                className={`cal_divs_single_bottom`} 
                            >
                                <h4 className='inner_calander_text'>
                                    {veryEndSum}
                                </h4>
                            </div>
                        )
                        arrayToPushForComparison[7] = routeSumMiddle
                        arrayToPushForComparison[15] = routeSumEnd
                        arrayToPushForComparison[23] = veryEndSum
                    }
                } else {
                    // seven version
                    for (let i = 0; i < 8; i++) {
                        lastWeekDivsArray.push(
                            <div className='cal_divs_single_bottom'  onClick={(e, item) => handleSetRoutesGiven(e, i)}>
                                <h4 className='inner_calander_text'>
                                    0
                                </h4>
                            </div>
                        )
                    }
                    for (let i = 0; i < 7; i++) {
                        let dateVar = new Date(localDate.setDate(localDate.getDate() + i)).toDateString()
                        localDate = new Date(props.selectedDate)
                        localDateArray.push(
                            dateVar
                        )
                    }
                    if (data.bottomArray) {
                        data.bottomArray.forEach( date => {
                            if (localDateArray.includes(date.date) && date.location === props.selectedCity) {
                                lastWeekDivsArray[localDateArray.indexOf(date.date) + 1] = (
                                    <div 
                                        className='cal_divs_single_bottom'
                                        onClick={(e, item) => handleSetRoutesGivenPut(e, date)}
                                    >
                                        <h4 className='inner_calander_text'>
                                            {parseInt(date.routeNumber)}
                                        </h4>
                                    </div>
                                )
                                routeSumMiddle += parseInt(date.routeNumber)
                                arrayToPushForComparison[localDateArray.indexOf(date.date)] = parseInt(date.routeNumber)
                            }
                        })
                        lastWeekDivsArray[8] = (
                            <div 
                                className={`cal_divs_single_bottom`} 
                            >
                                <h4 className='inner_calander_text'>
                                    {routeSumMiddle}
                                </h4>
                            </div>
                        )
                        arrayToPushForComparison[7] = routeSumMiddle
                    }
                }
                // make sure all data needed is available
                return lastWeekDivsArray
            }
        setRoutesGivenArray(arrayToPushForComparison)
        setTotalRoutesGiven(totalRoutesGiven())
    }, [data, props.selectedDate, props.selectedCity, props.divAmount, driverData])

    // handle making total spare da
    useEffect( () => {
        let amount = parseInt(props.divAmount)
        let localArray = []
        for ( let i = 0; i < 24; i++) {
            localArray.push(daAvailableArray[i] - routesGivenArray[i])
        }
        // bottom row spare da
        function totalSpareDa () {
            // make array for display and push forst column
            var lastWeekDivsArray = []
            lastWeekDivsArray.push(<div className='cal_divs_single_first_top_bottom'><h4 className='inner_calander_text'>Total Spare DA:</h4></div>)
            if (amount === 14) {
                for (let i = 0; i < 16; i++) {
                    if (localArray[i] > 0) {
                        lastWeekDivsArray.push(
                            <div className='cal_divs_single_bottom_positive'>
                                <h4 className='inner_calander_text'>
                                    {localArray[i]}
                                </h4>
                            </div>
                        )
                    } else {
                        lastWeekDivsArray.push(
                            <div className='cal_divs_single_bottom_negative'>
                                <h4 className='inner_calander_text'>
                                    {localArray[i]}
                                </h4>
                            </div>
                        )
                    }
                }
            } else if (amount === 21) {
                for (let i = 0; i < 24; i++) {
                    if (localArray[i] > 0) {
                        lastWeekDivsArray.push(
                            <div className='cal_divs_single_bottom_positive'>
                                <h4 className='inner_calander_text'>
                                    {localArray[i]}
                                </h4>
                            </div>
                        )
                    } else {
                        lastWeekDivsArray.push(
                            <div className='cal_divs_single_bottom_negative'>
                                <h4 className='inner_calander_text'>
                                    {localArray[i]}
                                </h4>
                            </div>
                        )
                    }
                }
            } else {
                for (let i = 0; i < 8; i++) {
                    if (localArray[i] > 0) {
                        lastWeekDivsArray.push(
                            <div className='cal_divs_single_bottom_positive'>
                                <h4 className='inner_calander_text'>
                                    {localArray[i]}
                                </h4>
                            </div>
                        )
                    } else {
                        lastWeekDivsArray.push(
                            <div className='cal_divs_single_bottom_negative'>
                                <h4 className='inner_calander_text'>
                                    {localArray[i]}
                                </h4>
                            </div>
                        )
                    }
                }
            }
            
            // make sure all data needed is available
            return lastWeekDivsArray
        }
        setTotalSpareDa(totalSpareDa())
    }, [daAvailableArray, routesGivenArray, driverData])

    // making the rows
    useEffect( () => {
        let totalTotal = 0
        let totalEnd = 0
        let amount = parseInt(props.divAmount)
        if (amount > 7 && amount < 15) {
            setCalendarDivs('cal_divs_single')
            setCalendarDivsInner('cal_divs_single_table')
            setCalendarDivsInnerBooked('cal_divs_single_booked')
            setMiddleRowClass('middle_row')
            setWeekGrid('single_week_grid')
        } else if (amount > 13) {
            setCalendarDivs('cal_divs_single_21')
            setCalendarDivsInner('cal_divs_single_table')
            setCalendarDivsInnerBooked('cal_divs_single_booked')
            setMiddleRowClass('middle_row_21')
            setWeekGrid('single_week_grid')
        } else {
            setCalendarDivs('cal_divs_single_seven')
            setCalendarDivsInner('cal_divs_single_table_seven')
            setCalendarDivsInnerBooked('cal_divs_single_booked_seven')
            setMiddleRowClass('middle_row_seven')
            setWeekGrid('single_week_grid')
        }
        // top row mapped divs
        var checkForDate = []
        function thisWeekDivs () {
            var thisWeekDivsArray = []
            let localDateArray = []
            let selectedDate = new Date(props.selectedDate)
            let selectedDateTwo = new Date(props.selectedDate)
            thisWeekDivsArray.push(<div className='cal_divs_single_first_top_two'><h4 className='inner_calander_text'>Da Name</h4></div>)
            if (amount === 14) {
                for (let i = 0; i < amount + 1; i++) {
                    if (i !== 7) {
                        let dateVar = new Date(selectedDate.setDate(selectedDate.getDate() + i)).toDateString()
                        let displayVar = new Date(selectedDateTwo.setDate(selectedDateTwo.getDate() + i)).toLocaleDateString('en-GB')
                        localDateArray.push(dateVar)
                        thisWeekDivsArray.push(<div key={i} className={`${calenderDivs}`}><h4 className='inner_calander_text'>{displayVar}</h4></div>)
                        selectedDate.setDate(selectedDate.getDate() - i )
                        selectedDateTwo.setDate(selectedDateTwo.getDate() - i )
                    } else {
                        selectedDateTwo.setDate(selectedDateTwo.getDate() - 1 )
                        selectedDate.setDate(selectedDate.getDate() - 1 )
                        localDateArray.push('total')
                        thisWeekDivsArray.push(<div key={i} className={`${calenderDivs}`}><h4 className='inner_calander_text'>Total</h4></div>)
                    }
                }  
                localDateArray.push('total')
                thisWeekDivsArray.push(<div className={`${calenderDivs}`}><h4 className='inner_calander_text'>Total</h4></div>)
            } else if ( amount === 21) {
                for (let i = 0; i < amount + 2; i++) {
                    if (i !== 7 && i !== 15) {
                        let dateVar = new Date(selectedDate.setDate(selectedDate.getDate() + i)).toDateString()
                        let displayVar = new Date(selectedDateTwo.setDate(selectedDateTwo.getDate() + i)).toLocaleDateString('en-GB')
                        localDateArray.push(dateVar)
                        thisWeekDivsArray.push(<div key={i} className={`${calenderDivs}`}><h4 className='inner_calander_text'>{displayVar}</h4></div>)
                        selectedDate.setDate(selectedDate.getDate() - i )
                        selectedDateTwo.setDate(selectedDateTwo.getDate() - i )
                    } else {
                        selectedDateTwo.setDate(selectedDateTwo.getDate() - 1 )
                        selectedDate.setDate(selectedDate.getDate() - 1 )
                        localDateArray.push('total')
                        thisWeekDivsArray.push(<div key={i} className={`${calenderDivs}`}><h4 className='inner_calander_text'>Total</h4></div>)
                    }
                }  
                localDateArray.push('total')
                thisWeekDivsArray.push(<div className={`${calenderDivs}`}><h4 className='inner_calander_text'>Total</h4></div>)
            } else {
                for (let i = 0; i < amount + 1; i++) {
                    if (i !== 7) {
                        let dateVar = new Date(selectedDate.setDate(selectedDate.getDate() + i)).toDateString()
                        let displayVar = new Date(selectedDateTwo.setDate(selectedDateTwo.getDate() + i)).toLocaleDateString('en-GB')
                        localDateArray.push(dateVar)
                        thisWeekDivsArray.push(<div key={i} className={`${calenderDivs}`}><h4 className='inner_calander_text'>{displayVar}</h4></div>)
                        selectedDateTwo.setDate(selectedDateTwo.getDate() - i )
                        selectedDate.setDate(selectedDate.getDate() - i )
                    } else {
                        localDateArray.push('total')
                        thisWeekDivsArray.push(<div key={i} className={`${calenderDivs}`}><h4 className='inner_calander_text'>Total</h4></div>)
                    }
                }  
            }
            checkForDate = localDateArray
            return thisWeekDivsArray
        }

        // total Da available function
        function totalDrivers () {
            // make array for display and push forst column
            let localMiddleSum = 0
            let localEndSum = 0
            let verylast = 0
            var lastWeekDivsArray = []
            lastWeekDivsArray.push(<div className='cal_divs_single_first_top_bottom'><h4 className='inner_calander_text'>Total DA Available:</h4></div>)

            
            // make sure all data needed is available
            if (driverData && props && checkForDate) {
                // create array to increment
                let localArray = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]

                // loop through each index in the amount of divs refrenced
                if (amount === 14 ) {
                    for (let i = 0; i < amount+2; i++) {
                        if (driverData) {
                            // check each date for each driver sum them
                            // eslint-disable-next-line no-loop-func
                            driverData[props.selectedCity].forEach( (ele) => {
                                if (!ele.Signed) {
                                    ele.datesList.forEach( (date) => {
                                        if (date.location === props.selectedCity) {
                                            if (date.date === checkForDate[i] && date.route !== 'Manager' && date.route !== 'Ride Along' && date.route !== 'Classroom Training') {
                                                localArray[i] = localArray[i] + 1
                                            }
                                        }
                                    })
                                }
                            })
                        }
                        lastWeekDivsArray.push(<div className='cal_divs_single_bottom'><h4 className='inner_calander_text'>{localArray[i]}</h4></div>)
                    }
                    for ( let i = 0; i < 7; i++) {
                        localMiddleSum += localArray[i]
                        localEndSum += localArray[i+8]
                    }
                    lastWeekDivsArray[8] = (
                        <div className='cal_divs_single_bottom'><h4 className='inner_calander_text'>{localMiddleSum}</h4></div>
                    )
                    lastWeekDivsArray[16] = (
                        <div className='cal_divs_single_bottom'><h4 className='inner_calander_text'>{localEndSum}</h4></div>
                    )
                    localArray[7] = localMiddleSum
                    localArray[15] = localEndSum
                } else if (amount === 21) {
                    for (let i = 0; i < amount+3; i++) {
                        if (driverData) {
                            // check each date for each driver sum them
                            // eslint-disable-next-line no-loop-func
                            driverData[props.selectedCity].forEach( (ele) => {
                                if (!ele.Signed) {
                                    ele.datesList.forEach( (date) => {
                                        if (date.location === props.selectedCity) {
                                            if (date.date === checkForDate[i] && date.route !== 'Manager' && date.route !== 'Ride Along' && date.route !== 'Classroom Training') {
                                                localArray[i] = localArray[i] + 1
                                            }
                                        }
                                    })
                                }
                            })
                        }
                        lastWeekDivsArray.push(<div className='cal_divs_single_bottom'><h4 className='inner_calander_text'>{localArray[i]}</h4></div>)
                    }
                    for ( let i = 0; i < 7; i++) {
                        localMiddleSum += localArray[i]
                        localEndSum += localArray[i+8]
                        verylast += localArray[i+16]
                    }
                    lastWeekDivsArray[8] = (
                        <div className='cal_divs_single_bottom'><h4 className='inner_calander_text'>{localMiddleSum}</h4></div>
                    )
                    lastWeekDivsArray[16] = (
                        <div className='cal_divs_single_bottom'><h4 className='inner_calander_text'>{localEndSum}</h4></div>
                    )
                    lastWeekDivsArray[24] = (
                        <div className='cal_divs_single_bottom'><h4 className='inner_calander_text'>{verylast}</h4></div>
                    )
                    localArray[7] = localMiddleSum
                    localArray[15] = localEndSum
                    localArray[24] = verylast
                } else {
                    for (let i = 0; i < amount+1; i++) {
                        if (driverData) {
                            // check each date for each driver sum them
                            // eslint-disable-next-line no-loop-func
                            driverData[props.selectedCity].forEach( (ele) => {
                                if (!ele.Signed) {
                                    ele.datesList.forEach( (date) => {
                                        if (date.location === props.selectedCity) {
                                            if (date.date === checkForDate[i] && date.route !== 'Manager' && date.route !== 'Ride Along' && date.route !== 'Classroom Training') {
                                                localArray[i] = localArray[i] + 1
                                            }
                                        }
                                    })
                                }
                            })
                        }
                        lastWeekDivsArray.push(<div className='cal_divs_single_bottom'><h4 className='inner_calander_text'>{localArray[i]}</h4></div>)
                    }
                    for ( let i = 0; i < 7; i++) {
                        localMiddleSum += localArray[i]
                    }
                    lastWeekDivsArray[8] = (
                        <div className='cal_divs_single_bottom'><h4 className='inner_calander_text'>{localMiddleSum}</h4></div>
                    )
                    localArray[7] = localMiddleSum
                }
                setDaAvailableArray(localArray)
            }
            return lastWeekDivsArray
        }

        // make nav invisbile
        const handleMouseLeave = () => {
            setMenuVisibility(null)
        }

        // make the nav visible
        const handleMouseEnterSeven = () => {
            setMenuVisibility(
                
            )
        }

        // get sundays
        const getSundaysSeven = () => {
            let bookingOptions = []
            let optionsArray = [
                'CT',
                'RT',
                'Holiday',
                'OFF'
            ]
            bookingOptions.push (
                <li className="menu-item" id='sub_menu_options' onMouseEnter={handleMouseEnterSeven} onMouseLeave={handleMouseLeave}>
                    <a href="#0" id='dropdown_text_rota' >
                        IN
                    </a>
                    {menuVisibility}
                </li>
            )
            optionsArray.forEach( ele => {
                bookingOptions.push(
                    <li className="menu-item" id='sub_menu_options'>
                        <a href="#0" id='dropdown_text_rota'>
                            {ele}
                        </a>
                    </li>
                )
            })
            return bookingOptions
        }

        // dropdown menu options
        // const optionsThree = getSundays()

        var middleRows
        // middle row mapped divs
        if (driverData && props && !props.deleteDriverScreen) {
            middleRows = () => {
                let mappedProps = []
                if (driverData) {
                    let x = 0
                    let localArray = [...driverData[props.selectedCity]]
                    localArray.sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1)
                    localArray.forEach( (ele, id) => {
                        if (determineOffboarded(ele.status, props.selectedDate)) {
                            mappedProps.push(
                                <RotaDriverRow 
                                    lockedWeekList={props.lockedWeekList}
                                    ele={ele}
                                    amount={amount}
                                    handleClick={handleClick}
                                    checkForDate={checkForDate}
                                    handleClickPut={handleClickPut}
                                    getSundaysSeven={getSundaysSeven}
                                    selectedCity={props.selectedCity}
                                    divAmount={props.divAmount}
                                    id={x}
                                />
                            )
                            x++
                        }
                    })
                }
                return mappedProps
            }
        } else {
            middleRows = () => {
                let myLocalVar = (
                    <div className='containerForLoader'>
                        <div class="spinner">
                            <div class="bounce1"></div>
                            <div class="bounce5"></div>
                            <div class="bounce4"></div>
                            <div class="bounce3"></div>
                            <div class="bounce2"></div>
                        </div>
                    </div>
                )
                return myLocalVar
            }
        }

        // send data to database from from
        const handleSubmitButton = (myDate, id, location) => {
            if (typeof location === typeof "blubber") {
                let latestLocalClick = `${myDate}${id}${location}`
                if (latestClick !== latestLocalClick) {
                    latestClick = `${myDate}${id}${location}`
                    // eslint-disable-next-line no-extend-native
                    Date.prototype.getWeek = function () {
                        var firstDate = new Date(this.getFullYear(), 0, 1)
                        if (this.getFullYear() === 2021) {
                            return Math.ceil((((new Date(this.getFullYear(), this.getMonth(), this.getDate()) - firstDate) / 86400000) + firstDate.getDay() + 1) / 7) - 1
                        } else {
                            return Math.ceil((((new Date(this.getFullYear(), this.getMonth(), this.getDate()) - firstDate) / 86400000) + firstDate.getDay() + 1) / 7)
                        }
                    }
                    let myDateTime = new Date()
                    let hours = myDateTime.getHours()
                    let minutes = myDateTime.getMinutes()
        
                    let timeEntry = `00:00`
                    async function postData(url = '', data = {}) {
                        let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
                        let originalText = bytes.toString(CryptoJS.enc.Utf8);
                        const response = await fetch(url, {
                            method: 'POST', 
                            mode: 'cors',
                            cache: 'no-cache',
                            credentials: 'same-origin',
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': `Token ${originalText}`
                            },
                            body: JSON.stringify(data)
                        });
            
                        return response ? response.json() : console.log('no reponse')
                    };
                    if (props.station) {
                            if (location === 'RT') {
                                postData(`https://backendpajamas.herokuapp.com/schedule/`, {
                                    date: myDate,
                                    logIn_time: timeEntry,
                                    logOut_time: timeEntry,
                                    location: props.selectedCity,
                                    driver_id: `https://backendpajamas.herokuapp.com/drivers/${id}/`,
                                    week_number: new Date(myDate).getWeek(),
                                    route: 'Ride Along',
                                    manager_id: props.userId,
                                    manager_movement: [`${props.userId}&${location}&${new Date()}`]
                                }).then( response => {
                                    if (data) {
                                        let matchingId = /\d+/.exec(response.driver_id)
                                        let localData = [...driverData[props.selectedCity]]
                                        localData.forEach( (driver, driverId) => {
                                            if (driver.driver_id === parseInt(matchingId[0])) {
                                                let localDriver = {...driver}
                                                let localDriverArray = [...localDriver.datesList, response]
                                                localDriver.datesList = localDriverArray
                                                localData[driverId] = localDriver
                                            }
                                        })
                                        let transientObj = {...driverData}
                                        transientObj[props.selectedCity] = localData
                                        setDriverData(transientObj)
                                        socketGate ? setSocketGate(false) : setSocketGate(true)
                                    }
                                })
                            } else if ( location === 'CT') {
                                postData(`https://backendpajamas.herokuapp.com/schedule/`, {
                                    date: myDate,
                                    logIn_time: timeEntry,
                                    logOut_time: timeEntry,
                                    location: props.selectedCity,
                                    driver_id: `https://backendpajamas.herokuapp.com/drivers/${id}/`,
                                    week_number: new Date(myDate).getWeek(),
                                    route: 'Classroom Training',
                                    manager_id: props.userId,
                                    manager_movement: [`${props.userId}&${location}&${new Date()}`]
                                }).then( response => {
                                    if (data) {
                                        let matchingId = /\d+/.exec(response.driver_id)
                                        let localData = [...driverData[props.selectedCity]]
                                        localData.forEach( (driver, driverId) => {
                                            if (driver.driver_id === parseInt(matchingId[0])) {
                                                let localDriver = {...driver}
                                                let localDriverArray = [...localDriver.datesList, response]
                                                localDriver.datesList = localDriverArray
                                                localData[driverId] = localDriver
                                            }
                                        })
                                        let transientObj = {...driverData}
                                        transientObj[props.selectedCity] = localData
                                        setDriverData(transientObj)
                                        socketGate ? setSocketGate(false) : setSocketGate(true)
                                    }
                                })
                            } 
                            else if (location === 'Manager') {
                                postData(`https://backendpajamas.herokuapp.com/schedule/`, {
                                    date: myDate,
                                    logIn_time: timeEntry,
                                    logOut_time: timeEntry,
                                    location: props.selectedCity,
                                    driver_id: `https://backendpajamas.herokuapp.com/drivers/${id}/`,
                                    week_number: new Date(myDate).getWeek(),
                                    route: 'Manager',
                                    manager_id: props.userId,
                                    manager_movement: [`${props.userId}&${location}&${new Date()}`]
                                }).then( response => {
                                    if (data) {
                                        let matchingId = /\d+/.exec(response.driver_id)
                                        let localData = [...driverData[props.selectedCity]]
                                        localData.forEach( (driver, driverId) => {
                                            if (driver.driver_id === parseInt(matchingId[0])) {
                                                let localDriver = {...driver}
                                                let localDriverArray = [...localDriver.datesList, response]
                                                localDriver.datesList = localDriverArray
                                                localData[driverId] = localDriver
                                            }
                                        })
                                        let transientObj = {...driverData}
                                        transientObj[props.selectedCity] = localData
                                        setDriverData(transientObj)
                                        socketGate ? setSocketGate(false) : setSocketGate(true)
                                    }
                                })
                            } else {
                                postData(`https://backendpajamas.herokuapp.com/schedule/`, {
                                    date: myDate,
                                    logIn_time: timeEntry,
                                    logOut_time: timeEntry,
                                    location: location,
                                    driver_id: `https://backendpajamas.herokuapp.com/drivers/${id}/`,
                                    week_number: new Date(myDate).getWeek(),
                                    manager_id: props.userId,
                                    manager_movement: [`${props.userId}&${location}&${new Date()}`]
                                }).then( response => {
                                    console.log(response)
                                    if (data) {
                                        let matchingId = /\d+/.exec(response.driver_id)
                                        let localData = [...driverData[props.selectedCity]]
                                        localData.forEach( (driver, driverId) => {
                                            if (driver.driver_id === parseInt(matchingId[0])) {
                                                let localDriver = {...driver}
                                                let localDriverArray = [...localDriver.datesList, response]
                                                localDriver.datesList = localDriverArray
                                                localData[driverId] = localDriver
                                            }
                                        })
                                        let transientObj = {...driverData}
                                        transientObj[props.selectedCity] = localData
                                        setDriverData(transientObj)
                                        socketGate ? setSocketGate(false) : setSocketGate(true)
                                    }
                                })
                            }
                        // } else {
                        //     setErrorMessage(
                        //         <div className='errorMessageAllPages'>
                        //             <h3 id='errorMessage'>Please contact supervisor if trying to alter data about driver not in your depot. </h3>
                        //             <button className='errorButton' onClick={handleDeleteError}>Return</button>
                        //         </div>
                        //     )
                        // }
                    } else {
                        if (location === 'RT') {
                            postData(`https://backendpajamas.herokuapp.com/schedule/`, {
                                date: myDate,
                                logIn_time: timeEntry,
                                logOut_time: timeEntry,
                                location: props.selectedCity,
                                driver_id: `https://backendpajamas.herokuapp.com/drivers/${id}/`,
                                week_number: new Date(myDate).getWeek(),
                                route: 'Ride Along',
                                manager_id: props.userId
                            }).then( response => {
                                if (data) {
                                    let matchingId = /\d+/.exec(response.driver_id)
                                    let localData = [...driverData[props.selectedCity]]
                                    localData.forEach( (driver, driverId) => {
                                        if (driver.driver_id === parseInt(matchingId[0])) {
                                            let localDriver = {...driver}
                                            let localDriverArray = [...localDriver.datesList, response]
                                            localDriver.datesList = localDriverArray
                                            localData[driverId] = localDriver
                                        }
                                    })
                                    let transientObj = {...driverData}
                                    transientObj[props.selectedCity] = localData
                                    setDriverData(transientObj)
                                    socketGate ? setSocketGate(false) : setSocketGate(true)
                                }
                            })
                        } else if ( location === 'CT') {
                            postData(`https://backendpajamas.herokuapp.com/schedule/`, {
                                date: myDate,
                                logIn_time: timeEntry,
                                logOut_time: timeEntry,
                                location: props.selectedCity,
                                driver_id: `https://backendpajamas.herokuapp.com/drivers/${id}/`,
                                week_number: new Date(myDate).getWeek(),
                                route: 'Classroom Training',
                                manager_id: props.userId
                            }).then( response => {
                                if (data) {
                                    let matchingId = /\d+/.exec(response.driver_id)
                                    let localData = [...driverData[props.selectedCity]]
                                    localData.forEach( (driver, driverId) => {
                                        if (driver.driver_id === parseInt(matchingId[0])) {
                                            let localDriver = {...driver}
                                            let localDriverArray = [...localDriver.datesList, response]
                                            localDriver.datesList = localDriverArray
                                            localData[driverId] = localDriver
                                        }
                                    })
                                    let transientObj = {...driverData}
                                    transientObj[props.selectedCity] = localData
                                    setDriverData(transientObj)
                                    socketGate ? setSocketGate(false) : setSocketGate(true)
                                }
                            })
                        } 
                        else if (location === 'Manager') {
                            postData(`https://backendpajamas.herokuapp.com/schedule/`, {
                                date: myDate,
                                logIn_time: timeEntry,
                                logOut_time: timeEntry,
                                location: props.selectedCity,
                                driver_id: `https://backendpajamas.herokuapp.com/drivers/${id}/`,
                                week_number: new Date(myDate).getWeek(),
                                route: 'Manager',
                                manager_id: props.userId
                            }).then( response => {
                                if (data) {
                                    let matchingId = /\d+/.exec(response.driver_id)
                                    let localData = [...driverData[props.selectedCity]]
                                    localData.forEach( (driver, driverId) => {
                                        if (driver.driver_id === parseInt(matchingId[0])) {
                                            let localDriver = {...driver}
                                            let localDriverArray = [...localDriver.datesList, response]
                                            localDriver.datesList = localDriverArray
                                            localData[driverId] = localDriver
                                        }
                                    })
                                    let transientObj = {...driverData}
                                    transientObj[props.selectedCity] = localData
                                    setDriverData(transientObj)
                                    socketGate ? setSocketGate(false) : setSocketGate(true)
                                }
                            }) 
                        }
                        else {
                            postData(`https://backendpajamas.herokuapp.com/schedule/`, {
                                date: myDate,
                                logIn_time: timeEntry,
                                logOut_time: timeEntry,
                                location: location,
                                driver_id: `https://backendpajamas.herokuapp.com/drivers/${id}/`,
                                week_number: new Date(myDate).getWeek(),
                                manager_id: props.userId
                            }).then( response => {
                                console.log(response)
                                if (data) {
                                    let matchingId = /\d+/.exec(response.driver_id)
                                    let localData = [...driverData[props.selectedCity]]
                                    localData.forEach( (driver, driverId) => {
                                        if (driver.driver_id === parseInt(matchingId[0])) {
                                            let localDriver = {...driver}
                                            let localDriverArray = [...localDriver.datesList, response]
                                            localDriver.datesList = localDriverArray
                                            localData[driverId] = localDriver
                                        }
                                    })
                                    let transientObj = {...driverData}
                                    transientObj[props.selectedCity] = localData
                                    setDriverData(transientObj)
                                    socketGate ? setSocketGate(false) : setSocketGate(true)
                                }
                            })
                        }
                    }
                }
            }
        }

        const handleSubmitButtonPut = (myDate, id, location) => {

            if (typeof location === typeof "blubber") {
                console.log(myDate, id, location)
                if (location === 'OFF') {
                    let driverIdentification = null
                    let scheduleDateId = -1
                    driverData[props.selectedCity].forEach( ele => {
                        if (ele.driver_id === id) {
                            driverIdentification = ele
                            ele.datesList.forEach( element => {
                                if (element.date === myDate) {
                                    scheduleDateId = element.date_id
                                }
                            })
                        }
                    })
                    async function getData(url = '') {
                        let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
                        let originalText = bytes.toString(CryptoJS.enc.Utf8);
                        const response = await fetch(url, {
                            method: 'GET', 
                            mode: 'cors',
                            cache: 'no-cache',
                            credentials: 'same-origin',
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': `Token ${originalText}`
                            },
                        });
            
                        return response ? response.json() : console.log('no reponse')
                    };
                    async function postData(url = '', data={}) {
                        let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
                        let originalText = bytes.toString(CryptoJS.enc.Utf8);
                        const response = await fetch(url, {
                            method: 'POST', 
                            mode: 'cors',
                            cache: 'no-cache',
                            credentials: 'same-origin',
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': `Token ${originalText}`
                            },
                            body: JSON.stringify(data)
                        });
            
                        return response ? response.json() : console.log('no reponse')
                    };

                    async function deleteData(url = '') {
                        let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
                        let originalText = bytes.toString(CryptoJS.enc.Utf8);
                        const response = await fetch(url, {
                            method: 'Delete', 
                            mode: 'cors',
                            cache: 'no-cache',
                            credentials: 'same-origin',
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': `Token ${originalText}`
                            },
                        });
                    };
                    getData(`https://backendpajamas.herokuapp.com/schedule/${scheduleDateId}/`).then( response => {
                        if (response.route) {
                            if (response.route !== '0' && new Date(response.date) < new Date()) {
                                setErrorMessage(
                                    <div className='errorMessageAllPages'>
                                        <h3 id='errorMessage'>This driver has Daily Service data. Delete through the Daily service. </h3>
                                        <button className='errorButton' onClick={handleDeleteError}>Return</button>
                                    </div>
                                )
                            } else {
                                deleteData(`https://backendpajamas.herokuapp.com/schedule/${scheduleDateId}/`).then( response => {
                                    let localData = [...driverData[props.selectedCity]]
                                    
                                    localData.forEach( (driver, driverId) => {
                                        if (driver.driver_id === driverIdentification.driver_id) {
                                            driver.datesList.forEach( (date, dateId) => {
                                                if (date.date_id === scheduleDateId) {
                                                    let localDriver = {...driver}
                                                    let localDriverArray = [...localDriver.datesList]
                                                    localDriverArray.splice(dateId, 1)
                                                    localDriver.datesList = localDriverArray
                                                    localData[driverId] = localDriver
                                                }
                                            })
                                        }
                                    })
                                    let transientObj = {...driverData}
                                    transientObj[props.selectedCity] = localData
                                    setDriverData(transientObj)
                                    socketGate ? setSocketGate(false) : setSocketGate(true)
                                })
                            }
                        }
                    })
                    
                } else {
                    async function getData(url = '') {
                        let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
                        let originalText = bytes.toString(CryptoJS.enc.Utf8);
                        const response = await fetch(url, {
                            method: 'GET', 
                            mode: 'cors',
                            cache: 'no-cache',
                            credentials: 'same-origin',
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': `Token ${originalText}`
                            },
                        });
            
                        return response ? response.json() : console.log('no reponse')
                    };
                    let scheduleDateId = -1
                    driverData[props.selectedCity].forEach( ele => {
                        if (ele.driver_id === id) {
                            ele.datesList.forEach( element => {
                                if (element.date === myDate) {
                                    scheduleDateId = element.date_id
                                }
                            })
                        }
                    })
                    let myDateTime = new Date()
                    let hours = myDateTime.getHours()
                    let minutes = myDateTime.getMinutes()
        
                    let timeEntry = `00:00`
                    getData(`https://backendpajamas.herokuapp.com/schedule/${scheduleDateId}/`).then( responseLocal => {
                        let localManagerList = responseLocal.manager_movement

                        localManagerList.push(`${props.userId}&${location}&${new Date()}`)
                        async function putData(url = '', data = {}) {
                            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
                            let originalText = bytes.toString(CryptoJS.enc.Utf8);
                            const response = await fetch(url, {
                                method: 'PUT', 
                                mode: 'cors',
                                cache: 'no-cache',
                                credentials: 'same-origin',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Authorization': `Token ${originalText}`
                                },
                                body: JSON.stringify(data)
                                });
                
                            return response ? response.json() : console.log('no reponse')
                        };
                        if (location === 'RT') {
                            putData(`https://backendpajamas.herokuapp.com/schedule/${scheduleDateId}/`, {
                                logIn_time: timeEntry,
                                logOut_time: timeEntry,
                                driver_id: `https://backendpajamas.herokuapp.com/drivers/${id}/`,
                                route: 'Ride Along',
                                manager_id: props.userId,
                                manager_movement: localManagerList
                            }).then( response => {
                                if (data) {
                                    let matchingId = /\d+/.exec(response.driver_id)
                                    let localData = [...driverData[props.selectedCity]]
                                    localData.forEach( (driver, driverId) => {
                                        if (driver.driver_id === parseInt(matchingId[0])) {
                                            let localDriver = {...driver}
                                            let localDriverArray = [...localDriver.datesList]
                                            localDriverArray.forEach( (date, dateId) => {
                                                if (date.date_id === response.date_id) {
                                                    localDriverArray[dateId] = response
                                                }
                                            })
                                            localDriver.datesList = localDriverArray
                                            localData[driverId] = localDriver
                                        }
                                    })
                                    let transientObj = {...driverData}
                                    transientObj[props.selectedCity] = localData
                                    setDriverData(transientObj)
                                    socketGate ? setSocketGate(false) : setSocketGate(true)
                                }
                            })
                        } else if ( location === 'CT') {
                            putData(`https://backendpajamas.herokuapp.com/schedule/${scheduleDateId}/`, {
                                logIn_time: timeEntry,
                                logOut_time: timeEntry,
                                driver_id: `https://backendpajamas.herokuapp.com/drivers/${id}/`,
                                route: 'Classroom Training',
                                manager_id: props.userId,
                                manager_movement: localManagerList
                            }).then( response => {
                                if (data) {
                                    let matchingId = /\d+/.exec(response.driver_id)
                                    let localData = [...driverData[props.selectedCity]]
                                    localData.forEach( (driver, driverId) => {
                                        if (driver.driver_id === parseInt(matchingId[0])) {
                                            let localDriver = {...driver}
                                            let localDriverArray = [...localDriver.datesList]
                                            localDriverArray.forEach( (date, dateId) => {
                                                if (date.date_id === response.date_id) {
                                                    localDriverArray[dateId] = response
                                                }
                                            })
                                            localDriver.datesList = localDriverArray
                                            localData[driverId] = localDriver
                                        }
                                    })
                                    let transientObj = {...driverData}
                                    transientObj[props.selectedCity] = localData
                                    setDriverData(transientObj)
                                    socketGate ? setSocketGate(false) : setSocketGate(true)
                                }
                            })
                        } 
                        else if ( location === 'Manager') {
                            putData(`https://backendpajamas.herokuapp.com/schedule/${scheduleDateId}/`, {
                                logIn_time: timeEntry,
                                logOut_time: timeEntry,
                                driver_id: `https://backendpajamas.herokuapp.com/drivers/${id}/`,
                                route: 'Manager',
                                manager_id: props.userId,
                                location: props.selectedCity,
                                manager_movement: localManagerList
                            }).then( response => {
                                if (data) {
                                    let matchingId = /\d+/.exec(response.driver_id)
                                    let localData = [...driverData[props.selectedCity]]
                                    localData.forEach( (driver, driverId) => {
                                        if (driver.driver_id === parseInt(matchingId[0])) {
                                            let localDriver = {...driver}
                                            let localDriverArray = [...localDriver.datesList]
                                            localDriverArray.forEach( (date, dateId) => {
                                                if (date.date_id === response.date_id) {
                                                    localDriverArray[dateId] = response
                                                }
                                            })
                                            localDriver.datesList = localDriverArray
                                            localData[driverId] = localDriver
                                        }
                                    })
                                    let transientObj = {...driverData}
                                    transientObj[props.selectedCity] = localData
                                    setDriverData(transientObj)
                                    socketGate ? setSocketGate(false) : setSocketGate(true)
                                }
                            })
                        }
                        else {
                            putData(`https://backendpajamas.herokuapp.com/schedule/${scheduleDateId}/`, {
                                logIn_time: timeEntry,
                                logOut_time: timeEntry,
                                location: location,
                                driver_id: `https://backendpajamas.herokuapp.com/drivers/${id}/`,
                                manager_id: props.userId,
                                manager_movement: localManagerList,
                                route: null
                            }).then( response => {
                                if (data) {
                                    let matchingId = /\d+/.exec(response.driver_id)
                                    let localData = [...driverData[props.selectedCity]]
                                    localData.forEach( (driver, driverId) => {
                                        if (driver.driver_id === parseInt(matchingId[0])) {
                                            let localDriver = {...driver}
                                            let localDriverArray = [...localDriver.datesList]
                                            localDriverArray.forEach( (date, dateId) => {
                                                if (date.date_id === response.date_id) {
                                                    localDriverArray[dateId] = response
                                                }
                                            })
                                            localDriver.datesList = localDriverArray
                                            localData[driverId] = localDriver
                                        }
                                    })
                                    let transientObj = {...driverData}
                                    transientObj[props.selectedCity] = localData
                                    setDriverData(transientObj)
                                    socketGate ? setSocketGate(false) : setSocketGate(true)
                                }
                            })
                        }
                    })
                }    
            }
        }
        
        // when click on a date to book
        const handleClick = _.throttle(function handleClicky (e, weekDaySelected, id, location) {
            e.preventDefault()
            let locationvar
            if (e.target) {
                if (Object.values(e.target)[1].children === 'IN') {
                    locationvar = props.selectedCity
                } else {
                    locationvar = Object.values(e.target)[1].children
                }
                handleSubmitButton(weekDaySelected, id, locationvar)
            }
        }, 5000)

        const handleClickPut = _.throttle(function handleClickPuty (e, weekDaySelected, id, location) {
            e.preventDefault()
            let locationvar
            if (e.target) {
                if (Object.values(e.target)[1].children === 'IN') {
                    locationvar = props.selectedCity
                } else {
                    locationvar = Object.values(e.target)[1].children
                }
                handleSubmitButtonPut(weekDaySelected, id, locationvar)
            }
        }, 5000)

        setTopRow(thisWeekDivs())
        let arrayToDisplay
        if (middleRows().length > 0) {
            arrayToDisplay = middleRows()
        } else {
            arrayToDisplay = (
                <div className='complianceLoading'>
                    <div className='containerForLoader'>
                        <div class="spinner">
                            <div class="bounce1"></div>
                            <div class="bounce5"></div>
                            <div class="bounce4"></div>
                            <div class="bounce3"></div>
                            <div class="bounce2"></div>
                        </div>
                    </div>
                </div>
            )
        }
        setTotalDaAvailable(totalDrivers())
        setMiddleRow(arrayToDisplay)
    }, [props.selectedDate, data, driverData, props, getData, calenderDivs, calenderDivsInner, calenderDivsInnerBooked, selectedResponse, menuVisibility, stateMenu])

    // function for handling class change for top
    useEffect( () => {

        // change the top class for each case
        switch (parseInt(props.divAmount)) {
            case 7:
                setTopClassName('top_row_seven')
                setBottomRows('bottom_row_7')
                setBottomRowContainers('bottom_rows_containers_7')
                break;
            case 14:
                setTopClassName('top_row')
                setBottomRows('bottom_row_14')
                setBottomRowContainers('bottom_rows_containers_14')
                break;
            case 21:
                setTopClassName('top_row_21')
                setBottomRows('bottom_row_21')
                setBottomRowContainers('bottom_rows_containers_21')
                break;
            default:
                setTopClassName('top_row')
        }
    }, [props.divAmount])

    return (
        <>
        {errorMessage}
        {handleSchedule}
        <div className={weekGrid}>
            <div className={topClassName}>
                {topRow}
            </div>
            <div className={`${middleRowClass}`}>
                {middleRow}
            </div>
            <div className={bottomRows}>
                <div className={bottomRowContainers}>
                    {totalRoutesGiven}
                </div>
                <div className={bottomRowContainers}>
                    {totalDaAvailable}
                </div>
                <div className={bottomRowContainers}>
                    {totalSpareDa}
                </div>
            </div>
        </div>
        </>
    )
}

export default DivSingleWeek
